import Vue from 'vue'
import App from './App.vue'
import axios from 'axios'
import router from "./router";

Vue.prototype.$axios = axios
axios.defaults.baseURL = '/api'

Vue.config.productionTip = false

new Vue({
  render: h => h(App),
  router,
}).$mount('#app')
